import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import Cart from './icons/Cart';
import Trash from './icons/Trash';
import Close from './icons/Close';
import { useGlobal } from '@/utils/useGlobal';
import { getIsAdvancedPurchase } from '@/service/customize-bundle-for-dpu';

export default function ShoppingCart({ carts, updateBundle }: any) {
    const { useLang, useState, useEffect, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang('customize_bundle_for_dpu.shopping_cart');
    const { locale } = useRouter();
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [totalOriginal, setTotalOriginal] = useState(0);
    const [totalNum, setTotalNum] = useState(0);
    const [open, setOpen] = useState(false);

    const goCheckout = (arr: any) => {
        let link = `https://${locale}.ecoflow.com/cart/`;
        arr?.map((cart: any, k: number) => {
            link += `${k > 0 ? ',' : ''}${cart?.variantId}:${cart?.quantity}`;
        });
        link += '?channel=buy_button';
        window.open(link, '_blank');
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_checkout',
            type: 'none',
            button_name: t('checkout'),
        });
    };

    const handleCheckout = async () => {
        try {
            const res = await getIsAdvancedPurchase(locale);
            if (res?.code === '0') {
                const finalCarts = res?.data ? carts : carts?.filter((cart: any) => cart?.id !== 'gift_trolley');
                goCheckout(finalCarts);
            } else {
                console.error(res?.message);
            }
        } catch (e) {
            console.error(e);
        } finally {
            // TODO: 有接口后需要remove finnaly
            goCheckout(carts);
        }
    };

    const handleChange = (data: any, n: number) => {
        if (!data?.parantVariantId) {
            return updateBundle({ ...data, quantity: n });
        }
        const parentTarget = carts?.find((cart: any) => cart?.variantId === data?.parantVariantId);
        if (parentTarget) {
            const childIdx = parentTarget?.children?.findIndex((child: any) => child?.variantId === data?.variantId);
            const tempChildren = JSON.parse(JSON.stringify(parentTarget?.children));
            if (childIdx !== -1) {
                return updateBundle({
                    ...parentTarget,
                    children: [...tempChildren?.slice(0, childIdx), { ...data, quantity: n }, ...tempChildren?.slice(childIdx + 1)],
                });
            }
        }
    };

    const handleToggleOpen = (e: any) => {
        e.stopPropagation();
        setOpen(!open);
    };

    const AddReduceCalc = ({ data, callback }: any) => {
        const NUM_MIN = data?.min || 0;
        const NUM_MAX = data?.inventory > data?.limit && data?.limit > 0 ? data?.limit : data?.inventory > 0 ? data?.inventory : 0;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 0);
        const [showMaxTip, setShowMaxTip] = useState(false);

        const reduceNumber = () => {
            if (data?.gift) return false;
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_remove_from_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number - 1,
                    button_name: '-',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const addNumber = () => {
            if (data?.gift) return false;
            if (number >= NUM_MAX) {
                setShowMaxTip(true);
                setTimeout(() => {
                    setShowMaxTip(false);
                }, 2000);
                return false;
            }
            setNumber(number + 1);
            callback(data, number + 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number + 1,
                    button_name: '+',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const inputChange = (e: any) => {
            if (data?.gift) return;
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v));
        };

        return (
            <div className="bundle-calculator">
                <div className={number <= NUM_MIN || data?.gift ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="24" height="24" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.545H15.7516C15.9291 12.545 16.0749 12.4939 16.1889 12.3916C16.303 12.2893 16.3601 12.1586 16.3601 11.9996C16.3601 11.8405 16.303 11.7098 16.1889 11.6075C16.0749 11.5052 15.9291 11.4541 15.7516 11.4541H8.24129C8.06381 11.4541 7.91804 11.5052 7.80395 11.6075C7.68986 11.7098 7.63281 11.8405 7.63281 11.9996C7.63281 12.1586 7.68986 12.2893 7.80395 12.3916C7.91804 12.4939 8.06381 12.545 8.24129 12.545Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {/* <div className="addSubtractor-number">{number}</div> */}
                <input className="addSubtractor-number" disabled={data?.gift} value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX || data?.gift ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="100%" height="100%" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.6088H11.388V15.7555C11.388 15.933 11.445 16.0788 11.5591 16.1929C11.6732 16.3069 11.819 16.364 11.9964 16.364C12.1739 16.364 12.3197 16.3069 12.4338 16.1929C12.5479 16.0788 12.6049 15.933 12.6049 15.7555V12.6088H15.7516C15.9291 12.6088 16.0749 12.5518 16.1889 12.4377C16.303 12.3236 16.3601 12.1778 16.3601 12.0004C16.3601 11.8229 16.303 11.6771 16.1889 11.563C16.0749 11.4489 15.9291 11.3919 15.7516 11.3919H12.6049V8.24519C12.6049 8.06772 12.5479 7.92194 12.4338 7.80785C12.3197 7.69376 12.1739 7.63672 11.9964 7.63672C11.819 7.63672 11.6732 7.69376 11.5591 7.80785C11.445 7.92194 11.388 8.06772 11.388 8.24519V11.3919H8.24129C8.06381 11.3919 7.91804 11.4489 7.80395 11.563C7.68986 11.6771 7.63281 11.8229 7.63281 12.0004C7.63281 12.1778 7.68986 12.3236 7.80395 12.4377C7.91804 12.5518 8.06381 12.6088 8.24129 12.6088Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {showMaxTip && <p className="reach-max">{t('reach_max')}</p>}
            </div>
        );
    };

    useEffect(() => {
        let tempDiscount = 0,
            tempOriginal = 0,
            tempNum = 0;
        carts?.map((cart: any) => {
            tempDiscount += cart?.discountPrice * cart?.quantity;
            tempOriginal += cart?.originalPrice * cart?.quantity;
            tempNum += cart?.quantity;
        });
        setTotalDiscount(tempDiscount);
        setTotalOriginal(tempOriginal);
        setTotalNum(tempNum);
    }, [carts]);

    return (
        <section className={`shopping-cart ${css['shopping-cart']} ${open ? 'open' : 'close'}`} onClick={() => setOpen(false)}>
            <div className="cart-outer" onClick={(e: any) => e.stopPropagation()}>
                {open && (
                    <div className="cart-inner">
                        <span className="close-icon" onClick={handleToggleOpen}>
                            <Close />
                        </span>
                        <div className="cart-header">
                            <span className="title">{t('title')}</span>
                            <div className="quantity">
                                <p className="q-t">{t('quantity')}</p>
                            </div>
                            <span className="price">{t('price')}</span>
                        </div>
                        <ul className="cart-body">
                            {carts?.map((cart: any) => (
                                <li className="cart" key={`${cart?.id}+${cart?.limit}+${cart?.quantity}`}>
                                    <div className="cart-info">
                                        <div className="cart-img">
                                            <EFPicture src={cart?.img} alt={cart?.name} />
                                        </div>
                                        <div className="cart-name-box">
                                            {/* {cart?.gift && <span className="gift">{t('gift')}</span>} */}
                                            <span className="cart-name">{cart?.name}</span>
                                            {cart?.delivery && (
                                                <p className="cart-delivery">
                                                    {cart?.id === 'dpu_battery'
                                                        ? 'If three or more battery packs are stacked, an EcoFlow Fixing Metal Tab is needed to hold them in position.'
                                                        : '*This item(s) will start shipping from the end of January.'}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <AddReduceCalc data={cart} callback={handleChange} />
                                    <div className="cart-price">
                                        <div className="price-box">
                                            <span className="discount-price">{FormatMoneyLocal(cart?.discountPrice, locale)}</span>
                                            {cart?.discountPrice !== cart?.originalPrice && (
                                                <span className="original-price">{FormatMoneyLocal(cart?.originalPrice, locale)}</span>
                                            )}
                                        </div>
                                        {!cart?.gift && !cart?.min && (
                                            <div className="trash-icon" onClick={() => handleChange(cart, 0)}>
                                                <Trash />
                                            </div>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                <div className="cart-fix-bar">
                    <div className="cart-bar-content">
                        <div className="total-cart-info">
                            <div className="price-install">
                                <div className="total-price">
                                    <span className="total-discount-price">{FormatMoneyLocal(totalDiscount, locale)}</span>
                                    {totalDiscount !== totalOriginal && <span className="total-original-price">{FormatMoneyLocal(totalOriginal, locale)}</span>}
                                    {totalDiscount !== totalOriginal && (
                                        <span className="total-save-price">
                                            {t('save')} {FormatMoneyLocal(totalOriginal - totalDiscount, locale)}
                                        </span>
                                    )}
                                </div>
                                {locale === 'us' && (
                                    <div className="install-box">
                                        <svg className="install-svg" width="37" height="19" viewBox="0 0 37 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M2.38782 13.271C1.93889 13.271 1.70836 13.0489 1.70836 12.6837C1.70836 12.0043 2.46669 11.7762 3.84867 11.6294C3.84867 12.5345 3.23594 13.2698 2.38418 13.2698L2.38782 13.271ZM2.98235 8.17866C1.99471 8.17866 0.859034 8.64336 0.242665 9.13476L0.805648 10.3238C1.30068 9.87124 2.09905 9.48419 2.81977 9.48419C3.50651 9.48419 3.88507 9.71351 3.88507 10.1758C3.88507 10.4852 3.63391 10.6429 3.16071 10.7048C1.38926 10.9341 0 11.4231 0 12.7881C0 13.8704 0.770461 14.5243 1.97408 14.5243C2.83311 14.5243 3.59751 14.0475 3.96151 13.4202V14.3545H5.5631V10.4403C5.5631 8.82657 4.4432 8.17501 2.98357 8.17501L2.98235 8.17866ZM19.0589 8.35459V14.3484H20.7733V11.4607C20.7733 10.0884 21.6033 9.68439 22.182 9.68439C22.4429 9.68197 22.6977 9.75719 22.9149 9.90158L23.2291 8.31697C22.9862 8.21984 22.7262 8.17279 22.4647 8.17866C21.5838 8.17866 21.0294 8.56813 20.6641 9.36165V8.35459H19.0589ZM31.1703 8.17744C30.2652 8.17744 29.5869 8.71373 29.2351 9.22939C28.9075 8.56207 28.2159 8.17866 27.3835 8.17866C26.4784 8.17866 25.8499 8.68097 25.5611 9.26094V8.35459H23.9074V14.3472H25.623V11.2617C25.623 10.1576 26.203 9.62373 26.7441 9.62373C27.2343 9.62373 27.6844 9.93919 27.6844 10.757V14.3472H29.3964V11.2617C29.3964 10.1406 29.9631 9.62373 30.5285 9.62373C30.9823 9.62373 31.4627 9.95132 31.4627 10.7461V14.3472H33.176V10.2037C33.176 8.8569 32.2696 8.17744 31.174 8.17744M14.8875 8.35459H13.3357V7.7455C13.3357 6.95198 13.7882 6.7263 14.1777 6.7263C14.4446 6.72994 14.7055 6.79546 14.9421 6.9168L15.4711 5.70832C15.4711 5.70832 14.9348 5.35889 13.9605 5.35889C12.8661 5.35889 11.62 5.97647 11.62 7.91415V8.35459H9.02593V7.7455C9.02593 6.95198 9.47728 6.7263 9.86798 6.7263C10.1349 6.7263 10.397 6.79182 10.6324 6.9168L11.1602 5.70832C10.8447 5.5239 10.3387 5.35889 9.65079 5.35889C8.55637 5.35889 7.31028 5.97647 7.31028 7.91415V8.35459H6.319V9.6759H7.31392V14.3472H9.02471V9.6759H11.6237V14.3472H13.3357V9.6759H14.8887V8.35337L14.8875 8.35459Z"
                                                fill="white"
                                            />
                                            <path d="M17.6209 8.35498H15.9102V14.3452H17.6209V8.35498Z" fill="white" />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M15.9727 7.33576H17.6483C18.6262 4.26241 21.9434 1.56034 25.8867 1.56034C30.6842 1.56034 34.8289 5.21245 34.8289 10.8981C34.8436 12.0652 34.6833 13.228 34.3533 14.3476H35.9792L35.9962 14.2918C36.2704 13.1828 36.4051 12.0447 36.399 10.9029C36.399 4.56332 31.7786 0 25.8904 0C21.2652 0 17.1423 3.21046 15.9739 7.33819L15.9727 7.33576Z"
                                                fill="#4A4AF4"
                                            />
                                        </svg>

                                        <p className="install-text">
                                            {t.rich('installation', {
                                                installation: FormatMoneyLocal(Math.round(totalDiscount / 6), locale),
                                            })}
                                        </p>
                                    </div>
                                )}
                            </div>
                            <div className="cart-icon" onClick={handleToggleOpen}>
                                <Cart />
                                <span className={`total-num ${totalNum > 99 ? 'over' : ''}`}>{totalNum > 99 ? '99+' : totalNum}</span>
                            </div>
                        </div>
                        <button className="checkout" onClick={handleCheckout}>
                            {t('checkout')}
                        </button>
                    </div>
                </div>
            </div>
            <style jsx global>
                {`
                    [class*='MicrosoftChat'] {
                        @media (max-width: 1024px) {
                            bottom: 180px !important;
                        }
                    }
                    .css-1q5c75 {
                        @media (max-width: 1024px) {
                            bottom: 180px !important;
                        }
                    }
                `}
            </style>
        </section>
    );
}
